// extracted by mini-css-extract-plugin
export default {"dark-mode":"global_dark-mode__4OZu6","chakra-ui-dark":"global_chakra-ui-dark__Q-L56"};